import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './index.css';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SecureAxiosClient from '../../auth/secure_axios';
import axios from 'axios';
import getConfig from '../../config';

class PostThread extends Component {

    constructor(props) {
        super(props);
        this.state = {
            thread: {}
        };

        this.createThread = this.createThread.bind(this);
        this.handleTitleUpdate = this.handleTitleUpdate.bind(this);
        this.handleUrlUpdate = this.handleUrlUpdate.bind(this);
        this.handleThemeImage = this.handleThemeImage.bind(this);
        this.archiveThread = this.archiveThread.bind(this);
    }

    async componentDidMount() {
        const { pathname } = this.props.location;
        const thread_id = pathname.split('/').slice(-1)[0];
        if (!thread_id) return;

        const config = getConfig();
        const thread_url = config.luigi.domain + config.luigi.services.thread + thread_id;
        const response = await axios.get(thread_url);
        const thread = response.data || {};
        this.setState({ thread });
    }

    handleTitleUpdate(event) {
        this.setState({ thread: { ...this.state.thread, title: event.target.value } });
    }

    handleUrlUpdate(event) {
        this.setState({ thread: { ...this.state.thread, url: event.target.value } });
    }

    handleThemeImage(event) {
        this.setState({ thread: { ...this.state.thread, theme_image: event.target.value } });
    }

    createThread(e) {
        e.preventDefault();
        const { thread } = this.state;
        console.log("Thread Data:", { thread });
        const config = getConfig();
        const self = this
        if(this.state.thread.id) {
            const updateThreadUrl = `${config.luigi.domain}${config.luigi.services.update_thread}${this.state.thread.id}`;
            console.log("Update Thread url:", updateThreadUrl);
            new SecureAxiosClient(true).put(
                updateThreadUrl,
                thread,
                (responseCode, responseData) => {
                    console.log("New thread created", responseData);
                    //Show Alert Stay in same page.
                    alert("Thread Updated");
                }
            )
        } else {
            const createThreadUrl = `${config.luigi.domain}${config.luigi.services.create_thread}`;
            console.log("Create Thread url:", createThreadUrl);
            new SecureAxiosClient(true).post(
                createThreadUrl,
                thread,
                (responseCode, responseData) => {
                    console.log("New thread created", responseData);
                    const threadUrl = "thread/" + responseData.id;
                    //Open Chat Page with newly created Thread.
                    self.props.history.push({
                        pathname: threadUrl,
                    });
                }
            )
        }
    }

    archiveThread(e) {
        e.preventDefault();
        const threadId = this.state.thread.id;
        console.log("Thread Id:", threadId);
        let config = getConfig();
        let archiveThreadUrl = `${config.luigi.domain}${config.luigi.services.archive_thread}/${threadId}`;
        console.log("Archive Thread url:", archiveThreadUrl);
        new SecureAxiosClient(true).put(
            archiveThreadUrl,
            null,
            (responseCode, responseData) => {
                console.log("Thread Archived", responseData);
                alert("Thread Deleted");
                //Open My Threads.
                this.props.history.goBack();
            }
        )
    }

    render() {
        return (
            <div className="page">
                <p className="title">{this.state.thread.id ? "Edit Page" : "Create New Thread"} </p>
                <form id='thread-info-form'>
                    <input type="text" placeholder="Title" value={this.state.thread.title} onChange={this.handleTitleUpdate} /> <br />
                    <input type="text" placeholder="Enter Url" value={this.state.thread.url} onChange={this.handleUrlUpdate} /> <br />
                    <input type="text" placeholder="Theme Image Url" value={this.state.thread.theme_image} onChange={this.handleThemeImage} />
                </form>

                <div className='action-buttons'>
                    <form onSubmit={this.createThread} id='thread-button'>
                        <input type="submit" value={this.state.thread.id ? "Edit Page" : "Create Thread"} />
                    </form>
                </div>
                {
                    this.state.thread.id &&
                    <Link className='create-button' onClick={this.archiveThread}>
                        Delete
                    </Link>
                }
            </div>
        )
    }
}

PostThread.propTypes = {
    user: PropTypes.object
  }
  
  const mapStateToProps = (state) => {
    return {
      user: state.user
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {};
  }
  
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostThread));